var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5386 3.68945H9.07859L3.80859 8.95945V16.4195L9.07859 21.6895H16.5386L21.8086 16.4195V8.95945L16.5386 3.68945ZM12.8086 17.9895C12.0886 17.9895 11.5086 17.4095 11.5086 16.6895C11.5086 15.9695 12.0886 15.3895 12.8086 15.3895C13.5286 15.3895 14.1086 15.9695 14.1086 16.6895C14.1086 17.4095 13.5286 17.9895 12.8086 17.9895ZM13.8086 13.6895H11.8086V7.68945H13.8086V13.6895Z",
    fill: "#178EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconSm);
export default __webpack_public_path__ + "static/media/info-icon-sm.d14358284207fa3276521bdb75009c0c.svg";
export { ForwardRef as ReactComponent };